<!-- Filter Controls Outside Table -->
<div class="variance-filter-toolbar">
  <div class="variance-filter-controls">
    <!-- Start of Search Bar For Big Screen -->
    <div *ngIf="screenWidth > 767">
      <div class="search-bar variance-table-search">
        <i tabindex="0" class="pi pi-search mr-2" pTooltip="click to search" tooltipPosition="bottom" (click)="submitGlobalFilter()" (keydown.enter)="submitGlobalFilter()" (click)="this.searchDialog=false" (keydown.enter)="this.searchDialog=false" style="margin: 4px 2px 0 0"></i>
        <input type="text" placeholder="Table Search" pInputText
          [(ngModel)]="filter.globalSearch"
          (keyup.enter)="submitGlobalFilter()" (keyup.enter)="this.searchDialog=false"
          class="searchStyle"/>
      </div>
    </div>
    <!-- End of Search Bar For Big Screen -->

    <!-- Start of Search Bar For Small Screen -->
    <div *ngIf="screenWidth <= 767" class="variance-mobile-search">
      <span pTooltip="Search" tooltipPosition="bottom">
        <p-button (click)="showSearchDialog()" icon="pi pi-search" styleClass="p-button-secondary"></p-button>
      </span>
    </div>
    <!-- End of Search Bar For Small Screen -->

    <div class="variance-quick-time-filter">
      <p-select [options]="quickTimeOptions"
                [ngModel]="lookbackPeriod"
                (onChange)="lookbackPeriodChange.emit($event.value)"
                aria-label="Quick time filter"
                styleClass="quick-time-select">
      </p-select>
    </div>

    <div id="serviceGrpApp" class="variance-filter-group">
      <app-service-grp-select [defaultService]="filter.serviceGroup" (serviceGrpSelected)="onServiceGrpChanged($event)"></app-service-grp-select>
    </div>

    <div id="locationApp" class="variance-location-filter" *ngIf="active || locationInitialized">
      <app-location-select
        [user]="authService.user"
        [footprint]="footprint"
        [deId]="deId"
        [filter]="locationSelectFilter"
        [showReset]="false"
        (locationSelected)="onLocationChanged($event)"
        (initComplete)="onLocationSelectInitialized($event)"
        (onClickReset)="deSelectChecks()"
        (clearTableSearch)="clearTableSearch()"
        >
      </app-location-select>
    </div>
  </div>

  <div class="variance-filter-actions">
    <app-refresh-button class="variance-filter-action" [disabled]="!dataLoaded" (refresh)="refreshToInitialState()"></app-refresh-button>

    <div class="variance-filter-action">
      <span pTooltip="Print" tooltipPosition="bottom">
        <p-button icon="pi pi-print" styleClass="p-button-secondary" (click)="printEhr()"></p-button>
      </span>
    </div>

    <div class="variance-filter-action">
      <span pTooltip="Advance Filter" tooltipPosition="bottom">
        <p-button icon="pi pi-filter" styleClass="p-button-secondary" [disabled]="!dataLoaded" (click)="openFilterModal()"></p-button>
      </span>
    </div>
  </div>
</div>

<p-table #dataTable [value]="records" [lazy]="true" (onLazyLoad)="loadRecordsLazy($event)" [paginator]="true" [rows]=20 [totalRecords]="totalCount">

    <ng-template pTemplate="header" let-columns>
        <tr>
          <th class="share-col-header" style="width:85px; border-top-left-radius: 10px;">
            <p-checkbox [(ngModel)]="masterSelected" [binary]="true" (onChange)="checkUncheckAll($event)"></p-checkbox>
          </th>
            <th *ngFor="let col of cols; let isLast = last" [pSortableColumn]="col.field" [style.border-top-right-radius]="isLast ? '10px' : '0'">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="cols" >
        <tr>
            <td>
              <p-checkbox [(ngModel)]="rowData.isSelected" (ngModelChange)="isPrint($event, rowData)" [binary]="true" styleClass="share-check"></p-checkbox>
            </td>
            <td style="height:50px" *ngFor="let col of cols">
              <span *ngIf="col.field !== 'MedDescription' && col.field !== 'Discrepancy' && (col.field !== 'UserName' && col.field !== 'PatientName' && col.field !== 'UserID' && col.field !== 'PatientID' && col.field !== 'Device')">{{rowData[col.field]}}</span>
              <span *ngIf="col.field === 'Discrepancy'">{{rowData[col.field] | formatQuantity}}</span>
              <span *ngIf="col.field === 'UserName'">{{isDeId(rowData.UserName)}}</span>
              <span *ngIf="col.field === 'PatientName'">{{isDeId(formatName(rowData.PatientName))}}</span>
              <span *ngIf="col.field === 'UserID'">{{isDeId(rowData.UserID)}}</span>
              <span *ngIf="col.field === 'PatientID'">{{isDeId(rowData.PatientID)}}</span>
              <span *ngIf="col.field === 'Device'">{{isDeId(rowData.Device)}}</span>
              <span  pTooltip="{{rowData[col.field]}}" *ngIf="col.field === 'MedDescription'">{{rowData[col.field] | slice:0:15}}{{rowData[col.field].length > 15 ? '..': ''}}</span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-toast position="top-center"></p-toast>
<p-dialog [(visible)]="tableDataIsLoading" [showHeader]="false" [resizable]="false" [modal]="true"
        [focusOnShow]="false" class="progress-overlay">
    <div style="width: 200px; height: 150; padding-top: 5%" class="text-center">
        <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
    </div>
</p-dialog>

<p-dialog
    header="Filter Data"
    [style]="{width: '40vw'}"
    class="filterHeader"
    [(visible)]="filterDialog"
    (onShow)="onShowModal()"
    (onHide)="onHideModal()">
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
              <!-- <p-datepicker appendTo="body" (onSelect)="updateEndDate()" [(ngModel)]="filter.startDate" placeholder="Start Date" inputId="start_date"></p-datepicker> -->
            <mat-form-field class="variance-filter-date">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="startPicker" [(ngModel)]="filterDraft.transactionStartDate" (dateChange)="filterDraft.transactionEndDate = filterDraft.transactionStartDate">
              <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
            </div>
            <div class="form-group">
                <label>User ID</label>
                <ng-select multiple="true" [(ngModel)]="filterDraft.UserID" [items]="filterOptions.adminId"  (search)="searchWithAutoComplete($event,'adminId','adminid')"></ng-select>
            </div>

            <!--<div class="form-group">
                <label>Admin Name</label>
                <ng-select multiple="true" [(ngModel)]="filter.UserName" [items]="filterOptions.adminName"  (search)="searchWithAutoComplete($event,'adminName','adminname')"></ng-select>

            </div>-->

            <div class="form-group">
                <label>Role</label>
                <ng-select multiple="true" bindValue="value" (clear)="resetDraftCode('UserType')" appendTo="body" [(ngModel)]="filterDraft.UserType" [items]="filterOptions.adminType" [virtualScroll]=true [searchFn]="ngSelectSearch"></ng-select>
            </div>

            <div class="form-group">
                <label>Stock Area</label>
                <ng-select multiple="true" bindValue="value" (clear)="resetDraftCode('Device')" appendTo="body" [items]="filterOptions.loc" [(ngModel)]="filterDraft.Device" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group">
              <!-- <p-datepicker appendTo="body" [(ngModel)]="filter.endDate" placeholder="End Date" inputId="end_date"></p-datepicker> -->
              <mat-form-field class="variance-filter-date">
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="endPicker" [(ngModel)]="filterDraft.transactionEndDate">
                <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="form-group">
                <label>Patient ID</label>
                <ng-select multiple="true" [(ngModel)]="filterDraft.PatientID" [items]="filterOptions.patientId"  (search)="searchWithAutoComplete($event,'patientId','patientid')"></ng-select>

            </div>
            <!--<div class="form-group">
                <label>Patient Name</label>
                <ng-select multiple="true" [(ngModel)]="filter.PatientName" [items]="filterOptions.patients"  (search)="searchWithAutoComplete($event,'patients','patientname')"></ng-select>

            </div>-->
            <div class="form-group">
                <label>Medication Description</label>
                <ng-select multiple="true" bindValue="value" (clear)="resetDraftCode('MedDescription')" appendTo="body" [items]="filterOptions.medDescription" [(ngModel)]="filterDraft.MedDescription" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
            </div>
            <p-footer>
                  <div class="form-group float-right mt-3">
                    <div class="form-group float-right mt-3">
                      <p-button label="Clear" icon="pi pi-trash" severity="info" styleClass="custom-filter-btn advanced-filter-action" (click)="clearFilter()"></p-button>
                      <p-button label="Cancel" icon="pi pi-times" severity="info" styleClass="custom-filter-btn advanced-filter-action" (click)="closeFilterModal()"></p-button>
                      <p-button label="Submit" icon="pi pi-check" severity="info" styleClass="custom-filter-btn advanced-filter-action" (click)="submitAdvancedFilter()"></p-button>
                    </div>
                  </div>
            </p-footer>
        </div>
    </div>

    <p-footer class="float-right"> </p-footer>
  </p-dialog>

  <p-dialog header="Select Options" [(visible)]="isPrintEhr" [style]="{width: '30vw'}" class="popUpHeader">
    <div class="print-options-content">
      <label class="print-option">
        <input class="print-option-checkbox" type="checkbox" name="deIdentifyData" [(ngModel)]="filter.deIdentifyData">
        <span class="print-option-label">De-Identify Data</span>
      </label>
    </div>
    <ng-template pTemplate="footer">
      <div class="print-options-footer">
        <p-button label="Cancel" icon="pi pi-times" severity="info" styleClass="custom-filter-btn" (click)="isPrintEhr=false"></p-button>
        <p-button label="Submit" icon="pi pi-check" severity="info" styleClass="custom-filter-btn" (click)="submitPrintFilter(); isPrintEhr=false"></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="searchDialog" [showHeader]="false" [modal]="true" [closable]="true" [dismissableMask]="true"
  [style]="{ width: '28rem'}" styleClass="rounded-dialog" [baseZIndex]="10000" appendTo="body">
<div class="search-bar">
<i tabindex="0" class="pi pi-search mr-2" pTooltip="click to search" tooltipPosition="bottom" (click)="submitGlobalFilter()" (keydown.enter)="submitGlobalFilter()" (click)="this.searchDialog=false" (keydown.enter)="this.searchDialog=false" style="margin: 4px 2px 0 0"></i>
<input type="text" placeholder="Table Search" pInputText [pAutoFocus]="true" [(ngModel)]="this.filter.globalSearch" class="searchStyle"
(keyup.enter)="submitGlobalFilter()" (keyup.enter)="this.searchDialog=false"/>
</div>
<ng-template pTemplate="footer">
<div class="dialog-footer-message">Hit enter to search</div>
</ng-template>
</p-dialog>
